import { defineComponent } from "vue";
import stethoscopeIcon from "@/assets/shared/stethoscope.svg";

export default defineComponent({
  props: {
    link: {
      type: String,
    },
  },
  data() {
    return {
      stethoscopeIconPath: stethoscopeIcon,
    };
  },
  methods: {
    openLink(url: string) {
      window.open(url, "_blank");
    },
  }
});
